<script lang="ts" setup>
import { watch } from 'vue'
import { useRoute, useRouter } from 'vue-router/composables'
import { useAgeGate } from '@/composables/useAgeGate'
import { useHistoryStore } from '@/stores'
import { useI18n } from '@/composables/useI18n'

const { t } = useI18n()
const { showAgeGate, confirmAgeGate } = useAgeGate()
const router = useRouter()
const route = useRoute()
const historyStore = useHistoryStore()

// 内容门控页面;弹窗展示期间通过浏览器返回/导航链接离开这些页面时,自动关闭弹窗
// (去往门控页时保持,由目标页 checkAgeGate 权威裁决重新弹出或关闭)
const GATED_ROUTES = ['book', 'chapter', 'chapter-scroll']

watch(() => route.name, (name) => {
  if (showAgeGate.value && !GATED_ROUTES.includes(name as string))
    showAgeGate.value = false
})

/**
 * 点击 No:关闭弹窗并返回上一页,不记录确认状态
 * - 无上级历史(广告/分享直达):回首页;全程走路由栈,不会退出应用
 * - 返回后的页面若也是 18+ 内容,由其自身的 checkAgeGate 重新弹出
 */
function onReject() {
  showAgeGate.value = false
  const url = historyStore.$pop()
  if (!url) {
    router.replace({ name: 'home' })
    return
  }
  router.replace(url)
}
</script>

<template>
  <!-- 不使用 BasicModal/portal:App 层级直接渲染,规避 root portal-target
       多 passenger 无 key diff 导致的 DOM 错位残留问题 -->
  <transition name="fade">
    <div v-if="showAgeGate" class="fixed inset-0 z-10000">
      <div class="fixed inset-0 bg-n-modal-mask" />
      <div class="w-272px absolute top-1/2 left-1/2 -translate-1/2 rounded-20px bg-n-modal-bg flex flex-col items-center px-18px pt-22px pb-18px">
        <div class="w-44px h-44px rounded-full btn-solid flex items-center justify-center">
          <span class="text-15px font-bold text-white">18+</span>
        </div>

        <p class="mt-14px text-16px font-bold text-n-text-1 text-center">
          {{ t('AgeGateTitle') }}
        </p>
        <p class="mt-6px text-12px text-n-text-2 text-center">
          {{ t('AgeGateDesc') }}
        </p>

        <a class="block mt-18px w-full h-40px lh-40px text-14px font-600 text-white text-center btn-solid rounded-full" @click="confirmAgeGate">
          {{ t('AgeGateConfirm') }}
        </a>
        <a class="block mt-10px w-full h-40px lh-40px text-14px font-500 text-n-text-2 text-center bg-n-bg-card border border-color-n-border-primary rounded-full" @click="onReject">
          {{ t('AgeGateCancel') }}
        </a>
      </div>
    </div>
  </transition>
</template>
